export const Key_Header = {
  IDC: 'IDC',
  EXT: 'EXT',
  NAM: 'NAM',
  KEW: 'KEW',
  NOR: 'NOR',
  YEM: 'YEM',
  COD: 'COD',
  INV: 'INV',
  REV: 'REV',
  APR: 'APR',
  MOB: 'MOB',
  DAM: 'DAM',
  DAE: 'DAE',
  DAC: 'DAC',
  STA: 'STA',
  CON: 'CON',
  ARE: 'ARE',
  SHO: 'SHO',
}
